<template>
    <div class="jobTable">
        <el-table :data="taskData" style="width: 100%">
            <el-table-column label="序号" type="index" :index="indexGender" width="60px" align="center">
            </el-table-column>
            <el-table-column label="任务名称" fit align="center" class-name="fileName">
                <template slot-scope="scope">
<!--                    <span v-if="scope.row.quests_type == 'test'">{{scope.row.name}}</span>-->
                    <router-link :to="'/'+dataType+'/detail?task_id='+scope.row.id+'&task_type='+scope.row.quests_type" title="点我查看任务详情">{{scope.row.name}}</router-link>
                </template>
            </el-table-column>
            <el-table-column label="任务文件" width="220px" align="center" class-name="fileList">
                <template slot-scope="scope">
                    <p v-for="file in scope.row.quests_files" :key="file.file_name" :title="file.file_name">
                        {{file.file_name}}
                    </p>
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" fit align="center">
            </el-table-column>
            <el-table-column label="操作" fit align="center">
                <template slot-scope="scope">
                    <button @click="changeJobStatus(scope.row.id, scope.row.quests_type, 'accept', scope.$index)">接收</button>
                    <button @click="changeJobStatus(scope.row.id, scope.row.quests_type, 'refuse', scope.$index)" :disabled="scope.row.quests_type == 'test'">拒绝</button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {changeJobStatus} from "../../api/translator";

    export default {
        name: "accept",
        props: {
            taskData:{type:Array, required:true},
            dataType:{type:String, required: true}
        },
        methods:{
            changeJobStatus(jobId, jobType, status, index){
                let actionText = status=="accept"?"接收":"拒绝"
                changeJobStatus(jobId, jobType, status)
                .then(res=>{
                    this.$message.success(`恭喜， ${actionText}任务成功 加油！`)
                    this.$emit("jumpToSubmit")
                })
                .catch(error=>{
                    this.$message.error(error.data.error)
                })
            },
            indexGender(index){
                return index+=1
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/translator/job.scss";
</style>